import { render, staticRenderFns } from "./WholesalePriceEdit.vue?vue&type=template&id=432200b2&"
import script from "./WholesalePriceEdit.vue?vue&type=script&lang=js&"
export * from "./WholesalePriceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports